export default class RestItemCategoriesModel {
    constructor({
      dbID,
      categoryType,
      image,
      name,
      offerType,
      restaurantMenuId,
      timeFrom,
      timeFrom2,
      timeFrom3,
      timeTo,
      timeTo2,
      timeTo3,
      type,
      visibility
    }) {
      this.dbID = dbID;
      this.categoryType = categoryType;
      this.image = image;
      this.name = name;
      this.offerType = offerType;
      this.restaurantMenuId = restaurantMenuId;
      this.timeFrom = timeFrom;
      this.timeFrom2 = timeFrom2;
      this.timeFrom3 = timeFrom3;
      this.timeTo = timeTo;
      this.timeTo2 = timeTo2;
      this.timeTo3 = timeTo3;
      this.type = type;
      this.visibility = visibility;
    }
  
    static fromJson(key, json) {
      return new RestItemCategoriesModel({
        dbID: key,
        categoryType: json["categoryType"],
        image: json["image"],
        name: json["name"],
        offerType: json["offerType"],
        restaurantMenuId: json["restaurantMenuId"],
        timeFrom: json["timeFrom"],
        timeFrom2: json["timeFrom2"],
        timeFrom3: json["timeFrom3"],
        timeTo: json["timeTo"],
        timeTo2: json["timeTo2"],
        timeTo3: json["timeTo3"],
        type: json["type"],
        visibility : json["visibility"] ?? "Yes"
      });
    }
  }
  